// extracted by mini-css-extract-plugin
export default {"video-link":"r_bX d-flex align-items-center my-2","video-link__link":"r_bY ml-2"};